/* VeeNourish product cards on Dwell: add to cart the same way Dwell's own product form does.
   Loaded as a module (like Dwell's scripts) so '@shopify/events' resolves through the theme's import map.
   pm-home.js calls window.VNDwellCart.add(button, variantId) and handles the fallback. */
import { CartLinesUpdateEvent } from '@shopify/events';

const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

async function add(button, variantId, quantity = 1) {
  const deferred = CartLinesUpdateEvent.createPromise();
  button.dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'add',
      context: 'product',
      lines: [{ merchandiseId: String(variantId), quantity }],
      promise: deferred.promise,
    })
  );

  try {
    const added = await fetch(`${root}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity }),
    }).then((r) => r.json());

    const cart = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json());
    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: { didError: Boolean(added.status), items: cart.items, source: 'vn-product-card', itemCount: quantity },
    });
    return added;
  } catch (error) {
    deferred.reject(error);
    throw error;
  }
}

window.VNDwellCart = { add };
